<script>
    export let day;
</script>

<div
    class="flex items-center justify-center bg-white
    text-primary font-primary
    border border-white
    text-sm print:text-[2.5vh]"
>
    {day.toUpperCase()}
</div>
